export const message_read = `subscription message_read{
    message_read
}`;
